import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9b83db8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderHold_Table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "OrderHold_Table_SyosiInfo OrderHold_Table_Sticky_TH" }, [
      /*#__PURE__*/_createTextVNode(" 書誌CD"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN13桁"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("ISBN ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderHold_Table_SyosiInfo OrderHold_Table_Sticky_TH_Second" }, " 書誌名 "),
    /*#__PURE__*/_createElementVNode("th", null, "良品"),
    /*#__PURE__*/_createElementVNode("th", null, "使用可能数"),
    /*#__PURE__*/_createElementVNode("th", null, "返品"),
    /*#__PURE__*/_createElementVNode("th", null, "取置"),
    /*#__PURE__*/_createElementVNode("th", null, "在庫"),
    /*#__PURE__*/_createElementVNode("th", null, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", null, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", null, "発売日"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderHold_Table_SyosiAuthor" }, "著者"),
    /*#__PURE__*/_createElementVNode("th", null, "受注保留数"),
    /*#__PURE__*/_createElementVNode("th", null, "保留設定")
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "OrderHold_Table_SyosiInfo OrderHold_Table_Sticky_TD Text_Left" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "OrderHold_Table_SyosiInfo OrderHold_Table_Sticky_TD_Second Text_Left" }
const _hoisted_8 = { class: "OrderHold_Table_SyosiAuthor" }
const _hoisted_9 = ["onClick"]

import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import ModalOrderHold from "../components/modal/ModalOrderHold.vue";
import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";
import BadgeHold from "../components/atoms/Badge/BadgeHold.vue";
import { OrderHoldData } from "../types/order";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderHold',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const store = useStore();
const route = useRoute();

const props = __props;
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

//Emitの定義


//ぱんくずヘッダー
const currentPathList = [{ name: "受注入力" }, { name: "受注保留解除" }];
// モーダルに渡す書誌情報---------------------------
// null or order型
let selectedOrder = ref({} as OrderHoldData);
// OrderHeaderに渡すフラグ--------------------------
let searchAreaToggle: boolean = true;

//モーダル開閉--------------------------------------
let modalVisible = ref(false);
const showModal = (order: OrderHoldData): void => {
  // console.log(order);

  selectedOrder.value = order;
  modalVisible.value = true;
};
const closeModal = (): void => {
  selectedOrder.value = {} as OrderHoldData;
  modalVisible.value = false;
};

//簡易検索-----------------------------------------
let isActive_KaniFlg = ref(false);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};

//詳細検索-----------------------------------------
let isActive_SyosaiFlg = ref(true);
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

// 検索条件開閉関連---------------------------------
// 開閉時の処理
let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
//テーブルの高さ判定
const tableHeight = () => {
  if (isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "OrderHold_TableContainer_Short";
  } else {
    //その他
    return "OrderHold_TableContainer_Long";
  }
};

// 保留実行処理------------------------------------
const setHold = (order: any): void => {
  if (confirm(`${order.syosiMei}を保留にします。よろしいですか？`)) {
    order.holdFlg = true;
  }
};

//保留解除処理-------------------------------------
const holdCancel = (): void => {
  // selectedOrder.holdFlg = false;
};

// 表示ステータス切替用フラグ----------------------
let statusAllFlg = ref(true);
let statusHoldFlg = ref(false);
let statusUnholdFlg = ref(false);

//表示ステータスリスト-----------------------------
// let selectBar_holdStatus = {
//   title: "保留状態",
//   select_list: [
//     { name: "すべて", selectFlg: true },
//     { name: "保留", selectFlg: false },
//     { name: "未保留", selectFlg: false },
//   ],
// };

// interface Status {
//   name: string;
//   selectFlg: boolean;
// }

//表示ステータス切替処理---------------------------
// const updateSelectHold = (newStatus: Status): void => {
//   newStatus.selectFlg = true;
//   statusAllFlg.value = false;
//   statusHoldFlg.value = false;
//   statusUnholdFlg.value = false;
//   if (newStatus.name == "すべて") {
//     statusAllFlg.value = true;
//   } else if (newStatus.name == "保留") {
//     statusHoldFlg.value = true;
//   } else {
//     statusUnholdFlg.value = true;
//   }
// };
// テーブル表示項目----------------------------------------------
let search_result = ref<OrderHoldData[]>([]);

//受注保留データの取得
const getOrderHoldData = async () => {
  await store.dispatch("search/searchOrderHold");
  const res = store.getters["search/getOrderHoldData"];
  search_result.value.splice(0);
  res.orderHoldList.forEach((orderHoldData: OrderHoldData) => {
    search_result.value.push(orderHoldData);
  });
};
// 在庫照会のテーブル内リンクから遷移した場合はcreated時にgetOrderHoldDataを呼ばない（searchSimple経由で呼ぶため）
if (route.query.syosiCd === undefined) getOrderHoldData();

const connectAuthor = computed(() => (order: OrderHoldData) => {
  order.author1 = order.author1 ? order.author1 : "";
  order.author2 = order.author2 ? order.author2 : "";
  order.author3 = order.author3 ? order.author3 : "";
  return order.author1 + order.author2 + order.author3;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderHold", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      onOnSearch: getOrderHoldData,
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea
    }, null, 8, ["isActive_SidebarFlg", "searchAreaToggle"]),
    (_unref(modalVisible))
      ? (_openBlock(), _createBlock(ModalOrderHold, {
          key: 0,
          selectedOrder: _unref(selectedOrder),
          onGetOrderHoldData: getOrderHoldData,
          onClose: closeModal,
          onOrderHoldCancel: holdCancel
        }, null, 8, ["selectedOrder"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["OrderHold_MainArea", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_1, [
        _hoisted_2,
        (_unref(statusAllFlg))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (order, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_4, [
                    _createTextVNode(_toDisplayString(order.syosiCd) + " ", 1),
                    _createVNode(BadgeHold),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(order.janCd) + " ", 1),
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(order.isbn), 1)
                  ]),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(order.title), 1),
                  _createElementVNode("td", null, _toDisplayString(order.items), 1),
                  _createElementVNode("td", null, _toDisplayString(order.availableAmount), 1),
                  _createElementVNode("td", null, _toDisplayString(order.returnItems), 1),
                  _createElementVNode("td", null, _toDisplayString(order.torioki), 1),
                  _createElementVNode("td", null, _toDisplayString(order.zsName), 1),
                  _createElementVNode("td", null, _toDisplayString(order.janCd), 1),
                  _createElementVNode("td", null, _toDisplayString(order.hontaiPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(order.releaseDate), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(connectAuthor.value(order)), 1),
                  _createElementVNode("td", null, _toDisplayString(order.holdSum), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (showModal(order)),
                      class: "OrderHold_Table_Button"
                    }, " 保留解除 ", 8, _hoisted_9)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 2))
}
}

})